import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {LanguageService} from '../../../../translation/Services/language.service';
import {DealerDashboardService} from '../../../Services/dealer-dashboard.service';

@Component({
  selector: 'app-dealer-dashboard-overview',
  templateUrl: './dealer-dashboard-overview.component.html',
  styleUrls: ['./dealer-dashboard-overview.component.scss']
})
export class DealerDashboardOverviewComponent implements OnInit {

  public grid: Grid;
  public blockId: number;
  public blockTitle: string;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(
    private router: Router,
    private dealerDashboardService: DealerDashboardService,
    private translateService: TranslateService,
    private broadCastService: BroadcastService,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.dealer_dashboard.title',
          prop: 'title',
          sortable: true,
          type: TextColumn.type,
          width: 300,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.dealer_dashboard.language',
          prop: 'language',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => row.name
        },
        <TextColumn>{
          name: 'global.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <NumberColumn>{
          name: 'doctrine.dealer_dashboard.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          maxWidth: 100,
          minWidth: 100,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.dealerDashboardService.setPosition(position, row.id).subscribe((res) => {
              this.broadCastService.broadcast('refreshGrid', 'getBlocks');
            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/dealer-dashboard/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.blockId = row.id,
                  this.blockTitle = row.title.bold(),
                  this.deleteModal.show();
              },
              showCallback: row => row.locked ? !row.locked : true,
              btnClass: 'ripple light ms-1'
            },
          ]
        },
      ],
      service: this.dealerDashboardService,
      rememberURL: this.router.url,
      method: 'getBlocks',
      defaultSort: 'position',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          name: 'language',
          type: 'ng-select',
          hasCalendar: false,
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          label: 'doctrine.download.language_name',
          hasStatus: false,
          value: new ServiceSearchItem(this.languageService, 'list', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            options.push({value: 'all', label: this.translateService.instant('global.all')});
            for (const row of res.languages) {
              options.push({value: row.name, label: row.name});
            }
            return options;
          })
        }
      ],
    };
  }

  delete() {
    this.dealerDashboardService.delete(this.blockId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadCastService.broadcast('refreshGrid', 'getBlocks');
    });
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/dealer-dashboard/archive');
  }
}
